//Add hover class for tile-card pattern if the heading is a link

let heading = document.getElementsByClassName('tiles-pattern__inner-column-heading');
            //console.log(heading)
let children = document.querySelectorAll('.tiles-pattern__inner-column-heading a');

if(children) {
    children.forEach(function (s) {

            let parentCard = s.parentElement.parentElement.parentElement.parentElement;
            parentCard.classList.add('tiles-pattern__hover')
    });
}